"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var R = _interopRequireWildcard(require("ramda"));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var _default = function _default(Froala) {
  Froala.PLUGINS.quote = function (editor) {
    var findParent = function findParent(element) {
      while (((_element = element) === null || _element === void 0 ? void 0 : _element.parentNode) !== editor.el && ((_element2 = element) === null || _element2 === void 0 ? void 0 : (_element2$parentNode = _element2.parentNode) === null || _element2$parentNode === void 0 ? void 0 : _element2$parentNode.tagName) !== 'BLOCKQUOTE') {
        var _element, _element2, _element2$parentNode;

        element = element.parentNode;
      }

      return element;
    };

    var increase = function increase() {
      var blocks = editor.selection.blocks();

      for (var i = 0; i < blocks.length; i++) {
        blocks[i] = findParent(blocks[i]);
      }

      editor.selection.save();
      var quote = editor.$(document.createElement('blockquote'));
      quote.insertBefore(blocks[0]);
      blocks.forEach(function (element) {
        return quote.append(element);
      });
      editor.html.unwrap();
      editor.selection.restore();
    };

    var decrease = function decrease() {
      var blocks = editor.selection.blocks();

      for (var i = 0; i < blocks.length; i++) {
        if ('BLOCKQUOTE' !== blocks[i].tagName) {
          blocks[i] = editor.$(blocks[i]).parentsUntil(editor.$el, 'BLOCKQUOTE').get(0);
        }
      }

      editor.selection.save();

      for (var _i = 0; _i < blocks.length; _i++) {
        blocks[_i] && editor.$(blocks[_i]).replaceWith(blocks[_i].innerHTML);
      }

      editor.html.unwrap();
      editor.selection.restore();
    };

    var apply = function apply(action) {
      editor.selection.save();
      editor.html.wrap(true, true, true, true);
      editor.selection.restore();
      R.cond([[R.equals('increase'), increase], [R.equals('decrease'), decrease]])(action);
    };

    var _init = function _init() {};

    return {
      _init: _init,
      apply: apply
    };
  };
};

exports.default = _default;